import { useEffect, useState } from 'react';

import { replaceURLPlaceholders } from '@yakit/ui-components';

export const useUpdateURLWithPattern = ({
  unresolvedURL,
  level0Code,
  selectedYear
}: {
  unresolvedURL: string | null | undefined;
  level0Code: string | undefined;
  selectedYear: number | null;
}) => {
  const [updatedURL, setUpdatedURL] = useState<string | null>(null);

  useEffect(() => {
    if (!unresolvedURL) return;

    const updatedIframe = replaceURLPlaceholders(unresolvedURL, {
      lvl_0: level0Code,
      year: selectedYear
    });

    setUpdatedURL(updatedIframe);
  }, [selectedYear, level0Code, unresolvedURL]);

  return { updatedURL };
};
